import i from"styled-components";import{theme as r}from"../../../../../theme.js";const t=({error:e=!1,checked:o})=>e?"#EA3100":o?"#2A71D4":"#94A3B8",s=i.div`
  width: fit-content;
  > label {
    display: flex;
    align-items: center;
    gap: ${r.spacing*2}px;
    flex-direction: ${({labelPosition:e})=>e==="left"?"row-reverse":"row"};
    cursor: pointer;
    > input {
      display: none;
    }
  }
`,c=i.div`
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border-radius: ${r.radius}px;
  border: 2px solid ${({error:e,checked:o})=>t({error:e,checked:o})};
  background-color: ${({checked:e})=>e?r.colors.primary[500]:r.colors.shades[0]};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .2s ease-in-out;
  > svg {
    width: 14px;
    height: 14px;
    > g, path {
      fill: ${r.colors.shades[0]};
    }
  }
  &:hover {
    border: 2px solid ${r.colors.primary[500]};
  }
`;export{c as Checkbox,s as Container};
